import React, { useState } from "react";
import { useI18n } from "../../i18n/i18nService";
import { useAuth } from "../../contexts/AuthContext";
import { getHashedDeviceId } from "../../utils/hash";
import { useNavigate } from "react-router-dom";
import { FlagLanguageSelector } from "../../components/LanguageSelector";
import ThemeToggle from "../../components/ThemeToggle";
import { ButtonCustom, FormError, InputField, ThemedCheckbox } from "../../components/common/Form";

const LoginPage = () => {
  const { t, i18n } = useI18n(['auth']);
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccess(false);
    const email = event.target.email.value;
    const password = event.target.password.value;
    const deviceId = await getHashedDeviceId();
    try {
      await login({ email, password, deviceId });
      setSuccess(true);
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 5000)

    } catch (error) {
      console.log(error);
      setError(t(`auth:errors.login.${error.status || 500}`));
      setSuccess(false);
      return;
    }

  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-light-background dark:bg-dark-background">
      <div className="max-w-md w-full p-6 relative rounded-lg shadow-idaraf dark:shadow-idaraf-dark bg-white dark:bg-gray-800">
        <div className="flex justify-center items-center mb-4">
          <img
            src="/images/logo.png" // Assurez-vous que le chemin est correct
            alt="IDARAF"
            className="h-28 w-28 object-contain rounded-full border border-light-tertiary/20 dark:border-dark-tertiary/20 p-1 dark:bg-gray-50"
          />
        </div>

        {/* 🧩 Formulaire de connexion */}
        {/* <h1 className="text-2xl font-bold mb-6 text-center">{t("login")}</h1> */}
        <form onSubmit={handleSubmit} className="space-y-4">

          <h2 className="text-2xl font-bold mb-6 text-center text-light-text/80 dark:text-dark-text">{t("auth:sign_in")}</h2>

          {error && <FormError message={error} />}
          {success && <div className="text-green-500">{t("login_success")}</div>}
{/*  */}
          <InputField
            name="email"
            label={t("auth:phone_or_email")}
            type="text"
            placeholder={t("auth:phone_or_email_placeholder")}
            autoComplete="username"
            required
          />

          <InputField
            name="password"
            label={t("auth:password")}
            type="password"
            placeholder={t("auth:password_placeholder")}
            autoComplete="current-password"
            required
          />

          <div className="flex justify-between items-center">
            <ThemedCheckbox
              label={t("auth:remember_me")}
              name="remember"
              id="remember"
              className="mr-2"
            />
            <a href="/forget-password" className="text-sm text-light-primary dark:text-dark-primary hover:underline">
              {t("auth:forgot_password")}
            </a>
          </div>

          <ButtonCustom
            type="submit"
            disabled={loading}
            variant="primary"
            className="w-full py-2 px-4 rounded-md text-white font-semibold"
          >
            {t("auth:submit")}
          </ButtonCustom>

          <div className="flex justify-between items-center mt-4">
            <div className="text-sm text-gray-600 dark:text-gray-400  ">
              {t("auth:no_account")}{" "}
              <a href="/register" className="text-light-primary dark:text-dark-primary hover:underline">
                {t("auth:sign_up")}
              </a>
            </div>
            <ThemeToggle />
          </div>
        </form>
        <div className="absolute top-5 right-5 flex items-center justify-center">
          <FlagLanguageSelector
            currentLanguage={i18n.language}
            onChange={changeLanguage}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
